"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.apiProductSelectedSupplierPurchaseUnit_delete = exports.api_product_selected_supplier_purchase_unit_delete_failure = exports.api_product_selected_supplier_purchase_unit_delete_success = exports.api_product_selected_supplier_purchase_unit_delete_request = exports.API_PRODUCT_SELECTED_SUPPLIER_PURCHASE_UNIT_DELETE_FAILURE = exports.API_PRODUCT_SELECTED_SUPPLIER_PURCHASE_UNIT_DELETE_SUCCESS = exports.API_PRODUCT_SELECTED_SUPPLIER_PURCHASE_UNIT_DELETE_REQUEST = undefined;

var _index = require("axios/index");

var _index2 = _interopRequireDefault(_index);

var _nodeToolbox = require("@esnpm/node-toolbox");

var _bluebird = require("bluebird");

var _bluebird2 = _interopRequireDefault(_bluebird);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var API_PRODUCT_SELECTED_SUPPLIER_PURCHASE_UNIT_DELETE_REQUEST = exports.API_PRODUCT_SELECTED_SUPPLIER_PURCHASE_UNIT_DELETE_REQUEST = "API_PRODUCT_SELECTED_SUPPLIER_PURCHASE_UNIT_DELETE_REQUEST";
var API_PRODUCT_SELECTED_SUPPLIER_PURCHASE_UNIT_DELETE_SUCCESS = exports.API_PRODUCT_SELECTED_SUPPLIER_PURCHASE_UNIT_DELETE_SUCCESS = "API_PRODUCT_SELECTED_SUPPLIER_PURCHASE_UNIT_DELETE_SUCCESS";
var API_PRODUCT_SELECTED_SUPPLIER_PURCHASE_UNIT_DELETE_FAILURE = exports.API_PRODUCT_SELECTED_SUPPLIER_PURCHASE_UNIT_DELETE_FAILURE = "API_PRODUCT_SELECTED_SUPPLIER_PURCHASE_UNIT_DELETE_FAILURE";

var api_product_selected_supplier_purchase_unit_delete_request = exports.api_product_selected_supplier_purchase_unit_delete_request = function api_product_selected_supplier_purchase_unit_delete_request(options) {
	return {
		type: API_PRODUCT_SELECTED_SUPPLIER_PURCHASE_UNIT_DELETE_REQUEST,
		options: options,
		payload: {
			loading: true
		}
	};
};

var api_product_selected_supplier_purchase_unit_delete_success = exports.api_product_selected_supplier_purchase_unit_delete_success = function api_product_selected_supplier_purchase_unit_delete_success(data) {
	return {
		type: API_PRODUCT_SELECTED_SUPPLIER_PURCHASE_UNIT_DELETE_SUCCESS,
		payload: {
			loading: false,
			data: data,
			error: null
		}
	};
};

var api_product_selected_supplier_purchase_unit_delete_failure = exports.api_product_selected_supplier_purchase_unit_delete_failure = function api_product_selected_supplier_purchase_unit_delete_failure(error) {
	return {
		type: API_PRODUCT_SELECTED_SUPPLIER_PURCHASE_UNIT_DELETE_FAILURE,
		payload: {
			loading: false,
			error: error
		}
	};
};

/*
	Products.apiProductSelectedSupplierPurchaseUnit_delete
*/
var apiProductSelectedSupplierPurchaseUnit_delete = exports.apiProductSelectedSupplierPurchaseUnit_delete = function apiProductSelectedSupplierPurchaseUnit_delete(options) {
	return (
		// eslint-disable-next-line no-unused-vars
		function (dispatch, getState) {
			return new _bluebird2.default(
			// eslint-disable-next-line no-unused-vars
			function (resolve, reject) {
				dispatch(api_product_selected_supplier_purchase_unit_delete_request(options));
				var url = (0, _nodeToolbox.getAPIUrl)([{ "parameters": ["PURCHASE_UNIT", "SKU"], "url": "/api/product/${options.SKU}/selected_supplier/purchase_unit/${options.PURCHASE_UNIT}" }], options);
				(0, _index2.default)({
					method: "delete",
					url: url
				}).then(function (response) {
					if (response.data.SUCCESSFUL) {
						dispatch(api_product_selected_supplier_purchase_unit_delete_success(response.data.DATA));
						resolve();
					} else {
						dispatch(api_product_selected_supplier_purchase_unit_delete_failure(response.data));
						resolve();
					}
				}, function (err) {
					// eslint-disable-next-line no-console
					console.log(err);
					reject();
				});
			});
		}
	);
};